import { useState } from "react";
import ScenarioEditDialog from "./scenario-edit-dialog";
import ScenarioInfoDialog from "./scenario-info-dialog";
import { ScenarioResponse } from "@Shared/schemas/scenarios/scenarioSchemas";

/**
 * This component is part of the VR app V2 redesign
 */

interface IScenarioDialogWrapper {
  open: boolean;
  scenario?: ScenarioResponse;
  scenarioEditorData?: any;
  onClose: () => void;
  onCreate?: () => void;
  onUpdate?: () => void;
  onDelete: () => void;
}

const ScenarioDialogWrapper = ({ onClose, ...props }: IScenarioDialogWrapper) => {
  const [edit, setEdit] = useState(false);

  const handleClose = () => (edit ? setEdit(false) : onClose());

  return edit ? (
    <ScenarioEditDialog onClose={handleClose} {...props} />
  ) : !!props.scenario ? (
    <ScenarioInfoDialog open={props.open} scenario={props.scenario} onDelete={props.onDelete} onClose={onClose} onEdit={() => setEdit(!edit)} />
  ) : null;
};

export default ScenarioDialogWrapper;
